import { useTranslation } from './useTranslation'

export const useGetText = () => useTranslation().t
